module.exports = "/wwwroot/img/map-mobile.png?ver=4b3816d3";